export default "__VITE_ASSET__QPYLqW02__"